// extracted by mini-css-extract-plugin
export default {"button":"vp_epK9P","label":"vp_FRIrw","symbol":"vp_Wksyh","icon":"vp_fidTu","iconOff":"vp_eBZuq","active":"vp_ygAug","iconOn":"vp_fUZid"};